// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3qKIQ","info":"UpdateTermsInfo_info__1dr1l"};